import { DOCUMENT_URL, CHANGE_LOG_UEL } from "../config/link";

/**
 * @description - 跳转到速问 API 文档
 * */
export const goSWApiDocument = () => {
  window.open(DOCUMENT_URL, "_blank");
};

/**
 * @description - 跳转到速问更新日志
 * */
export const goSWChangeLog = () => {
  window.open(CHANGE_LOG_UEL, "_blank");
}